import { Injectable, inject } from "@angular/core";
import { WebinstallningarService } from "~app/common/services/webinstallningar/webinstallningar.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { INode } from "../models/layer-node.model";
import { IDefault, IDefaults } from "../models/perisist-default.model";

@Injectable({
    providedIn: "root"
})
export class PersistService {
    throttle: any;

    private readonly webInstallningarService = inject(WebinstallningarService);

    destroy() {
        // Krav
    }

    getLayerOpacity(layerid: string, defaults: IDefaults, defaultValue: number) {
        return defaults?.defaults.find(x => x.layerid === layerid)?.opacity ?? defaultValue;
    }

    getVisibleSublayerIds(layerid: string, defaults: IDefaults): number[] {
        return defaults?.defaults.filter(x => x.layerid === layerid &&
            x.visible === true &&
            ObjectUtils.hasValue(x.sublayerid)).map(x => x.sublayerid);
    }

    init(id: string, nodes: INode[]) {
        nodes.forEach(n => {
            n.opacityChanged
                .subscribe(node => {
                    this.persist(id, nodes);
                });
            n.checkChanged
                .subscribe(node => {
                    this.persist(id, nodes);
                });
        });
    }

    isVisible(layerid: string, defaults: IDefaults): boolean {
        return defaults?.defaults.some(x => x.layerid === layerid && x.visible === true);
    }

    load(id: string) {
        return this.webInstallningarService.getAsync<IDefaults>(this.getKey(id));
    }

    save(id: string, roots: INode[]) {
        const defaults = { defaults: [] } as IDefaults;
        this.updateDefaults(roots, defaults.defaults);
        this.webInstallningarService.setAsync(this.getKey(id), defaults).then(() => {
            // Exekvera promise
        });
    }

    private getKey(id: string): string {
        return `lager_${id}`;
    }

    private persist(id: string, roots: INode[]): void {
        if (this.throttle) {
            clearTimeout(this.throttle);
        }
        this.throttle = setTimeout(() => {
            this.save(id, roots);
        }, 1000);
    }

    private updateDefaults(nodes: INode[], defaults: IDefault[]): void {
        nodes?.forEach(node => {
            if (node.checked) {
                defaults.push({
                    id: node.id,
                    layerid: node.layerid,
                    sublayerid: node.sublayerid,
                    sublayerName: node.sublayerName,
                    visible: node.checked,
                    opacity: node.opacity
                });
            }
            this.updateDefaults(node.nodes, defaults);
        });
    }
}
